import { systemChartColors } from '@e3dc-react/theme/e3dc/config'
import { systemChartColors as flowSystemChartColors } from '@e3dc-react/theme/flow/config'
import type { TraceKey } from './traceKey'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * Get color for chart object (eg. BAR) according to theme
 */
export const getChartColor = (key: TraceKey): string => {
  return isFlowTheme ? flowSystemChartColors[key] : systemChartColors[key]
}
